import {createSlice} from "@reduxjs/toolkit";

const initialMetricsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  tripForEdit: undefined,
  entities: null,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const metricsSlice = createSlice({
  name: "metrics",
  initialState: initialMetricsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findMetrics
    healthFetched: (state, action) => {
      const { totalCount, entities, queryParams } = action.payload;
      state.listLoading = false;
      state.error = null;
      //console.log("total", entities.length, "page size", queryParams.pageSize, "page num", queryParams.pageNumber, "slicing ", queryParams.pageSize * (queryParams.pageNumber -1), "to", queryParams.pageSize * queryParams.pageNumber)
      state.entities = entities; //.slice(queryParams.pageSize * (queryParams.pageNumber -1), queryParams.pageSize * queryParams.pageNumber);
      state.totalCount = totalCount;
    },
  }
});
